import React from 'react';
import { ArrowDownIcon, CodeBracketIcon, CloudIcon, DevicePhoneMobileIcon } from '@heroicons/react/24/outline';

const Hero: React.FC = () => {
  return (
    <section id="about" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-600 via-blue-600 to-indigo-700 overflow-hidden" aria-labelledby="hero-heading">
      <div className="absolute inset-0 bg-black opacity-10"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="animate-fade-in">
          <div className="mb-8 mt-2">
            <div className="w-32 h-32 mx-auto bg-white rounded-full flex items-center justify-center shadow-2xl">
              <CodeBracketIcon className="w-16 h-16 text-primary-600" />
            </div>
          </div>
          
          <h1 id="hero-heading" className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Hi, I'm <span className="text-yellow-300">Luis Panta</span>
          </h1>
          
          <h2 className="text-xl md:text-2xl lg:text-3xl text-blue-100 mb-8 font-light">
            Full-Stack Developer & Solution Architect
          </h2>
          <p className="sr-only">
            Luis Panta is a professional full-stack developer and solution architect with expertise in Laravel, React, Vue, AWS, and cloud architecture.
          </p>
          
          <p className="text-lg md:text-xl text-blue-50 mb-12 max-w-3xl mx-auto leading-relaxed">
            Passionate about building scalable web applications, APIs, and innovative digital solutions. 
            Specialized in modern technologies including Laravel, React, Vue, and cloud architecture.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <a href="#projects" className="btn-primary">
              View My Work
            </a>
            <a href="#contact" className="btn-secondary bg-white text-primary-600 border-white hover:bg-gray-100">
              Get In Touch
            </a>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 border border-white border-opacity-20">
              <CloudIcon className="w-12 h-12 text-yellow-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-white mb-2">Cloud Architecture</h3>
              <p className="text-blue-100">AWS, Docker, scalable solutions</p>
            </div>
            
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 border border-white border-opacity-20">
              <CodeBracketIcon className="w-12 h-12 text-yellow-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-white mb-2">Full-Stack Development</h3>
              <p className="text-blue-100">Laravel, React, Vue, APIs</p>
            </div>
            
            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-xl p-6 border border-white border-opacity-20">
              <DevicePhoneMobileIcon className="w-12 h-12 text-yellow-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-white mb-2">Performance Optimization</h3>
              <p className="text-blue-100">250% faster applications</p>
            </div>
          </div>
        </div>
        
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ArrowDownIcon className="w-8 h-8 text-white opacity-70" />
        </div>
      </div>
      
      <div className="absolute top-20 left-10 w-72 h-72 bg-yellow-300 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-300 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-pulse"></div>
    </section>
  );
};

export default Hero;